import { Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from "@mui/material";
import containerStyles from "../TotalContainer/index.module.css";
import tableStyles from "../../PricingTable/index.module.css";

const formatMoney = (value, currency) => {
  const amount = Number(value) || 0;
  try {
    const formatted = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: String(currency || "CAD").toUpperCase(),
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
    return `${formatted} ${String(currency || "CAD").toUpperCase()}`;
  } catch {
    return `$${amount.toFixed(2)}`;
  }
};

const formatMethod = (adjustment = {}) => {
  if (adjustment.calculationType === "percentage") {
    return `${Number(adjustment.value) || 0}% discount`;
  }
  return "Fixed discount";
};

const AdjustmentContainer = ({ adjustments = [], currency = "CAD" }) => {
  if (!Array.isArray(adjustments) || !adjustments.length) return null;

  return (
    <Grid container className={containerStyles.headerContainer}>
      <Typography variant="h6">Adjustments</Typography>
      <TableContainer component={Paper} className={`${tableStyles.tableContainer} document-table sticky-header`}>
        <Table className={tableStyles.table}>
          <TableHead>
            <TableRow className={tableStyles.tableRow}>
              <TableCell className={`${tableStyles.tableHeaderCell} ${tableStyles.firstColumnItem} ${tableStyles.firstServiceColumnItem}`}>
                ADJUSTMENT
              </TableCell>
              <TableCell className={tableStyles.tableHeaderCell}>METHOD</TableCell>
              <TableCell className={tableStyles.tableHeaderCell}>AMOUNT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {adjustments.map((adjustment, index) => (
              <TableRow key={adjustment.id || index} className={tableStyles.tableRow}>
                <TableCell className={`${tableStyles.tableCell} ${tableStyles.firstColumnItem} ${tableStyles.firstServiceColumnItem}`}>
                  <Box style={{ width: "100%" }}>
                    {adjustment.description || "Customer Discount"}
                  </Box>
                </TableCell>
                <TableCell className={tableStyles.tableCell}>
                  <Box style={{ width: "100%" }}>{formatMethod(adjustment)}</Box>
                </TableCell>
                <TableCell className={tableStyles.tableCell}>
                  <Box style={{ width: "100%", fontWeight: 700 }}>
                    {formatMoney(adjustment.resolvedAmount, currency)}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.75 }}>
        Discounts are applied before tax. Tax is calculated on the adjusted subtotal.
      </Typography>
    </Grid>
  );
};

export default AdjustmentContainer;
